import TimePicker from "./time_picker";
import Pikaday from "pikaday";

// `DateTimeHint` shows a datetime-picker hint.
export default class DateTimeHint {
  constructor($el, $container, token, params, query) {
    this.$el = $el;
    this.$container = $container;
    this.token = token;
    this.params = params;
    this.query = query;
    let [dateText, timeText, zoneText] = this.token.value().split(/\s/, 3);
    const date = this.textToDateInUserZone(dateText);
    if (timeText && !timeText.match(/^\d?\d:\d\d$/)) {
      timeText = null;
    }
    if (zoneText && !zoneText.match(/^UTC[-+]?\d{0,3}$/)) {
      zoneText = null;
    }
    this.datePicker = new Pikaday({
      onSelect: () => this.onDateTimeChange(),
      setDefaultDate: true,
      keyboardInput: false,
      defaultDate: date,
    });
    this.timePicker = new TimePicker(timeText, zoneText, () =>
      this.onDateTimeChange(),
    );
    this.$container.html(this.params.template);
    this.$container
      .find(".picker")
      .append(this.datePicker.el)
      .append(this.timePicker.el);
    this.showOrHideTimePicker();
    this.$container.show();
  }

  textToDateInUserZone(dateText) {
    // The date needs to be in the user's timezone to keep pikaday happy
    if (dateText.match(/^\d\d\d\d-\d\d-\d\d$/)) {
      const date = new Date(dateText);
      date.setHours(date.getHours() + date.getTimezoneOffset() / 60);
      return date;
    }
    return null;
  }

  onDateTimeChange() {
    this.showOrHideTimePicker();
    if (!this.datePicker.getDate()) {
      this.datePicker.setDate(new Date());
    }
    const fragments = [
      this.datePicker.toString(),
      this.timePicker.time(),
      this.timePicker.zone(),
    ].filter((f) => f);
    this.query.replaceToken(this.token.cloneWithNewValue(fragments.join(" ")));
  }

  setToken(token) {
    this.token = token;
  }

  destroy() {
    this.datePicker.destroy();
    this.timePicker.destroy();
  }

  showOrHideTimePicker() {
    if (this.datePicker.getDate()) {
      this.timePicker.show();
    } else {
      this.timePicker.hide();
    }
  }
}
